"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingRequiredPropertiesError = exports.AllowedMediaHostnameIsEmptyOrInvalidError = exports.DuplicatedRequiredPermissionsError = exports.UnknownRequiredPermissionsError = exports.FileNotFoundError = exports.InvalidSceneConfigFileError = exports.InvalidWearableConfigFileError = exports.InvalidBuilderConfigFileError = exports.FileTooBigError = exports.ModelFileNotFoundError = exports.WrongExtensionError = void 0;
class WrongExtensionError extends Error {
    constructor(file) {
        super(`The file ${file} has a wrong extension`);
    }
}
exports.WrongExtensionError = WrongExtensionError;
class ModelFileNotFoundError extends Error {
    constructor() {
        super('The file does not contain a model file');
    }
}
exports.ModelFileNotFoundError = ModelFileNotFoundError;
class FileTooBigError extends Error {
    geFileName() {
        return this.fileName;
    }
    geFileSize() {
        return this.fileSize;
    }
    getMaxFileSize() {
        return this.maxFileSize;
    }
    getType() {
        return this.type;
    }
    constructor(fileName, fileSize, maxFileSize, type) {
        super(`The file ${fileName} too big (${fileSize} bytes) but should be less than ${maxFileSize} bytes for the ${type} type.`);
        this.fileName = fileName;
        this.fileSize = fileSize;
        this.maxFileSize = maxFileSize;
        this.type = type;
    }
}
exports.FileTooBigError = FileTooBigError;
class InvalidBuilderConfigFileError extends Error {
    getErrors() {
        return this.errors;
    }
    constructor(errors) {
        super('The builder config file is invalid');
        this.errors = errors;
    }
}
exports.InvalidBuilderConfigFileError = InvalidBuilderConfigFileError;
class InvalidWearableConfigFileError extends Error {
    getErrors() {
        return this.errors;
    }
    constructor(errors) {
        super('The wearable config file is invalid');
        this.errors = errors;
    }
}
exports.InvalidWearableConfigFileError = InvalidWearableConfigFileError;
class InvalidSceneConfigFileError extends Error {
    getErrors() {
        return this.errors;
    }
    constructor(errors) {
        super('The scene config file is invalid');
        this.errors = errors;
    }
}
exports.InvalidSceneConfigFileError = InvalidSceneConfigFileError;
class FileNotFoundError extends Error {
    constructor(fileName) {
        super(`The file ${fileName} does not exist.`);
    }
}
exports.FileNotFoundError = FileNotFoundError;
class UnknownRequiredPermissionsError extends Error {
    getUnknownRequiredPermissions() {
        return this.unknownRequiredPermissions;
    }
    constructor(unknownRequiredPermissions) {
        super(`The following required permissions do not exist: ${unknownRequiredPermissions}.`);
        this.unknownRequiredPermissions = unknownRequiredPermissions;
    }
}
exports.UnknownRequiredPermissionsError = UnknownRequiredPermissionsError;
class DuplicatedRequiredPermissionsError extends Error {
    getDuplicatedRequiredPermissions() {
        return this.duplicatedRequiredPermissions;
    }
    constructor(duplicatedRequiredPermissions) {
        super(`Some required permissions are duplicated: ${duplicatedRequiredPermissions}. Please remove the duplicates.`);
        this.duplicatedRequiredPermissions = duplicatedRequiredPermissions;
    }
}
exports.DuplicatedRequiredPermissionsError = DuplicatedRequiredPermissionsError;
class AllowedMediaHostnameIsEmptyOrInvalidError extends Error {
    constructor() {
        super("The property 'allowedMediaHostnames' is empty or invalid.");
    }
}
exports.AllowedMediaHostnameIsEmptyOrInvalidError = AllowedMediaHostnameIsEmptyOrInvalidError;
class MissingRequiredPropertiesError extends Error {
    getMissingProperties() {
        return this.missingProperties;
    }
    constructor(missingProperties) {
        super(`The following required properties are missing: ${missingProperties}`);
        this.missingProperties = missingProperties;
    }
}
exports.MissingRequiredPropertiesError = MissingRequiredPropertiesError;
//# sourceMappingURL=files.errors.js.map